import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  repoOwnerLabel: {
    id: 'bitkit.refLabel.repoOwnerLabel',
    description: 'Label for the repository owner',
    defaultMessage: 'Owner',
  },
  repoWorkspaceLabel: {
    id: 'bitkit.refLabel.repoWorkspaceLabel',
    description: 'Label for the repository workspace',
    defaultMessage: 'Workspace',
  },
  repoNameLabel: {
    id: 'bitkit.refLabel.repoNameLabel',
    description: 'Label for the repository name',
    defaultMessage: 'Repository',
  },
  branchLabel: {
    id: 'bitkit.refLabel.branchLabel',
    description: 'Label for the branch name',
    defaultMessage: 'Branch',
  },
  deletedRepository: {
    id: 'bitkit.refLabel.deletedRepository',
    description: 'String informing that the repository does not exist anymore.',
    defaultMessage: 'Deleted repository',
  },
  openLinkLabel: {
    id: 'bitkit.refLabel.openLink',
    description: 'Aria label for link with info about opening entity',
    defaultMessage: '{name}, {type}',
  },
});
